import { api } from "api";

export const getOrganisationActivities = (onBegin, onSuccess, onError) => {
  return async (dispatch) => {
    onBegin();
    await api
      .get("/api/organization/get-organizational-activities")
      .then((res) => {
        dispatch({
          type: "GET_ORG_ACTIVITIES_SUCCESS",
          payload: res.data,
        });

        onSuccess();
      })
      .catch((e) => {
        dispatch({
          type: "GET_ORG_ACTIVITIES_ERROR",
          payload: e,
        });
        onError(e);
      });
  };
};

export const getMyTeam = (onBegin, onSuccess, onError) => {
  return async (dispatch) => {
    onBegin();
    await api
      .get("/api/organization/get-my-team")
      .then((res) => {
        dispatch({
          type: "GET_MY_TEAM_SUCCESS",
          payload: res.data.data,
        });

        onSuccess(res);
      })
      .catch((e) => {
        dispatch({
          type: "GET_MY_TEAM_ERROR",
          payload: e,
        });
        onError(e);
      });
  };
};

export const getMyTeamExport = (onBegin, onSuccess, onError) => {
  return async (dispatch) => {
    onBegin();
    await api
      .get(`/api/organization/export-my-team`)
      .then((res) => {
        const fileName = res.headers["content-disposition"].split(';')[1].split('=')[1];
        onSuccess(res, fileName);
      })
      .catch((e) => {
        dispatch({
          type: "EXPORT_MY_TEAM_ERROR",
          payload: e,
        });
        onError(e);
      });
  };
};
